import { Update } from '@ngrx/entity';
import { Action } from '@ngrx/store';
import { TrainingRecordEntity } from './training-record.model';

/* eslint-disable @typescript-eslint/no-shadow */
export enum TrainingRecordActionTypes {
  LoadTrainingRecords = '[TrainingRecord] Load TrainingRecords',
  AddTrainingRecord = '[TrainingRecord] Add TrainingRecord',
  UpsertTrainingRecord = '[TrainingRecord] Upsert TrainingRecord',
  AddTrainingRecords = '[TrainingRecord] Add TrainingRecords',
  UpsertTrainingRecords = '[TrainingRecord] Upsert TrainingRecords',
  UpdateTrainingRecord = '[TrainingRecord] Update TrainingRecord',
  UpdateTrainingRecords = '[TrainingRecord] Update TrainingRecords',
  DeleteTrainingRecord = '[TrainingRecord] Delete TrainingRecord',
  DeleteTrainingRecords = '[TrainingRecord] Delete TrainingRecords',
  ClearTrainingRecords = '[TrainingRecord] Clear TrainingRecords',
}
/* eslint-enable @typescript-eslint/no-shadow */

export class LoadTrainingRecords implements Action {
  public readonly type = TrainingRecordActionTypes.LoadTrainingRecords;

  constructor(public payload: { trainingRecords: TrainingRecordEntity[] }) {}
}

export class AddTrainingRecord implements Action {
  public readonly type = TrainingRecordActionTypes.AddTrainingRecord;

  constructor(public payload: { trainingRecord: TrainingRecordEntity }) {}
}

export class UpsertTrainingRecord implements Action {
  public readonly type = TrainingRecordActionTypes.UpsertTrainingRecord;

  constructor(public payload: { trainingRecord: TrainingRecordEntity }) {}
}

export class AddTrainingRecords implements Action {
  public readonly type = TrainingRecordActionTypes.AddTrainingRecords;

  constructor(public payload: { trainingRecords: TrainingRecordEntity[] }) {}
}

export class UpsertTrainingRecords implements Action {
  public readonly type = TrainingRecordActionTypes.UpsertTrainingRecords;

  constructor(public payload: { trainingRecords: TrainingRecordEntity[] }) {}
}

export class UpdateTrainingRecord implements Action {
  public readonly type = TrainingRecordActionTypes.UpdateTrainingRecord;

  constructor(public payload: { trainingRecord: Update<TrainingRecordEntity> }) {}
}

export class UpdateTrainingRecords implements Action {
  public readonly type = TrainingRecordActionTypes.UpdateTrainingRecords;

  constructor(public payload: { trainingRecords: Update<TrainingRecordEntity>[] }) {}
}

export class DeleteTrainingRecord implements Action {
  public readonly type = TrainingRecordActionTypes.DeleteTrainingRecord;

  constructor(public payload: { id: string }) {}
}

export class DeleteTrainingRecords implements Action {
  public readonly type = TrainingRecordActionTypes.DeleteTrainingRecords;

  constructor(public payload: { ids: string[] }) {}
}

export class ClearTrainingRecords implements Action {
  public readonly type = TrainingRecordActionTypes.ClearTrainingRecords;
}

export type TrainingRecordActions =
  | LoadTrainingRecords
  | AddTrainingRecord
  | UpsertTrainingRecord
  | AddTrainingRecords
  | UpsertTrainingRecords
  | UpdateTrainingRecord
  | UpdateTrainingRecords
  | DeleteTrainingRecord
  | DeleteTrainingRecords
  | ClearTrainingRecords;
